import logo from '/logo.svg';
import { classNames } from '@utils/classNames';

export function Logo({ className }: { className?: string }) {
  return (
    <img
      src={logo}
      alt="Logo"
      className={classNames('h-10 w-40 text-black', className)}
    />
  );
}
